import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Button, Card, CardContent, Container, Stack, TextField, Typography } from "@mui/material";
import { updatePassword } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import linguistApi from "services/linguistApi";

const LinguistInvitationSetup = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const savePassword = async () => {
    if (!auth.currentUser) {
      setError("You need to sign in first.");
      return;
    }

    if (password.length < 12) {
      setError("Please choose a password with at least 12 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await updatePassword(auth.currentUser, password);
      // Fire-and-forget password-changed notification (non-blocking)
      linguistApi.post("/notify-password-changed").catch(() => {});
      setMessage("Your password has been updated.");
      navigate("/linguist-portal", { replace: true });
    } catch (requestError) {
      setError(requestError?.message || "Unable to update your password.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Box>
              <Typography variant="h5" fontWeight={800}>Complete your setup</Typography>
              <Typography variant="body2" color="text.secondary">
                Set a new password for your portal account.
              </Typography>
            </Box>

            {message ? <Alert severity="success">{message}</Alert> : null}
            {error ? <Alert severity="error">{error}</Alert> : null}

            <TextField label="New password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} fullWidth />
            <TextField label="Confirm password" type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} fullWidth />
            <Button variant="contained" onClick={savePassword}>Save password</Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default LinguistInvitationSetup;